import React from "react";
import MapView from "@/components/MapView";

export default function MapsPage() {
  return (
    <div className="space-y-4" data-testid="maps-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#d4a574] mb-2 font-semibold">Interactive Intelligence Map</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Every distressed asset. Nationwide.</h1>
      </div>
      <MapView height={720} />
    </div>
  );
}
